export class RankingNode {
    public id: any;
    public name: string;
    public position: number;
    public highlighted?: boolean;
    public preventDrag?: boolean;

    [key: string]: any;

    constructor(id: any, name: string, position: number) {
      this.id = id;
      this.name = name;
      this.position = position;
    }
}
